var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMultiples(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5E616E",
    stroke: "#191D26",
    strokeWidth: 0.667,
    clipPath: "url(#arrows_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.333 8.333h3.333v3.333h-3.333zM8.333 8.333h3.333v3.333H8.333zM8.333 4.333h3.333v3.333H8.333zM4.333 4.333h3.333v3.333H4.333zM4.333 16.333h3.333v3.333H4.333zM.333 16.333h3.333v3.333H.333zM4.333.333h3.333v3.333H4.333zM4.333 12.333h3.333v3.333H4.333zM.333.333h3.333v3.333H.333zM8.333 12.333h3.333v3.333H8.333z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#9194A1",
    stroke: "#1B1F28",
    strokeWidth: 0.667,
    clipPath: "url(#arrows_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.333 8.333h3.333v3.333h-3.333zM36.333 8.333h3.333v3.333h-3.333zM36.333 4.333h3.333v3.333h-3.333zM32.333 4.333h3.333v3.333h-3.333zM32.333 16.333h3.333v3.333h-3.333zM28.333 16.333h3.333v3.333h-3.333zM32.333.333h3.333v3.333h-3.333zM32.333 12.333h3.333v3.333h-3.333zM28.333.333h3.333v3.333h-3.333zM36.333 12.333h3.333v3.333h-3.333z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#C7C9D1",
    stroke: "#1D1F2B",
    strokeWidth: 0.667,
    clipPath: "url(#arrows_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.333 8.333h3.333v3.333h-3.333zM64.333 8.333h3.333v3.333h-3.333zM64.333 4.333h3.333v3.333h-3.333zM60.333 4.333h3.333v3.333h-3.333zM60.333 16.333h3.333v3.333h-3.333zM56.333 16.333h3.333v3.333h-3.333zM60.333.333h3.333v3.333h-3.333zM60.333 12.333h3.333v3.333h-3.333zM56.333.333h3.333v3.333h-3.333zM64.333 12.333h3.333v3.333h-3.333z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#20212E",
    strokeWidth: 0.667,
    clipPath: "url(#arrows_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.333 8.333h3.333v3.333h-3.333zM92.333 8.333h3.333v3.333h-3.333zM92.333 4.333h3.333v3.333h-3.333zM88.333 4.333h3.333v3.333h-3.333zM88.333 16.333h3.333v3.333h-3.333zM84.333 16.333h3.333v3.333h-3.333zM88.333.333h3.333v3.333h-3.333zM88.333 12.333h3.333v3.333h-3.333zM84.333.333h3.333v3.333h-3.333zM92.333 12.333h3.333v3.333h-3.333z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrows_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arrows_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28 0h16v20H28z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arrows_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56 0h16v20H56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "arrows_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M84 0h16v20H84z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMultiples);
export default __webpack_public_path__ + "static/media/arrow-multiples.add043a23e2eddf4b560926689482b09.svg";
export { ForwardRef as ReactComponent };